import setupErrorGuard from './error'

export default function setupRouteGuard(router) {
  setupErrorGuard(router)
}
